// Kickback Club (loyalty page) motion — IntersectionObserver reveals + scroll spy + sticky CTA.
// Wszystko idempotentne, unobserve po pierwszym reveal, respect prefers-reduced-motion.

function initLoyaltyMotion() {
  const root = document.querySelector('main.kb-loyalty');
  if (!root) return;
  if (root.__kbInited) return;
  root.__kbInited = true;

  const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1) Scroll reveals — IntersectionObserver na wszystko z [data-reveal].
  const reveals = root.querySelectorAll('[data-reveal]');
  if (reveals.length && !prefersReduce && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  // 2) Anchor nav scroll spy — obserwuje sekcje, aktywny link ma .is-active.
  const anchorLinks = root.querySelectorAll('[data-loy-anchor]');
  const sections = ['access', 'rewards', 'level-up', 'tiers', 'faq']
    .map((id) => document.getElementById(id))
    .filter(Boolean);

  if (anchorLinks.length && sections.length && 'IntersectionObserver' in window) {
    const setActive = (id) => {
      anchorLinks.forEach((a) => {
        a.classList.toggle('is-active', a.getAttribute('data-loy-anchor') === id);
      });
    };
    const spy = new IntersectionObserver((entries) => {
      // Znajdź entry z najwyższym intersectionRatio wśród visible
      let best = null;
      entries.forEach((e) => {
        if (e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) {
          best = e;
        }
      });
      if (best) setActive(best.target.id);
    }, { rootMargin: '-40% 0px -40% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] });
    sections.forEach((s) => spy.observe(s));

    // Smooth scroll na click (native scroll-behavior:smooth via CSS też działa)
    anchorLinks.forEach((a) => {
      a.addEventListener('click', (ev) => {
        const targetId = a.getAttribute('href')?.replace('#', '');
        const target = targetId && document.getElementById(targetId);
        if (target) {
          ev.preventDefault();
          target.scrollIntoView({ behavior: prefersReduce ? 'auto' : 'smooth', block: 'start' });
          setActive(targetId);
        }
      });
    });
  }

  // 3) Tiers tabs — klik tier → panel z tego tier slide-in z prawej.
  const tiersRoot = document.querySelector('[data-loy-tiers]');
  if (tiersRoot) {
    const tabs = tiersRoot.querySelectorAll('[data-loy-tier-tab]');
    const panels = tiersRoot.querySelectorAll('[data-loy-tier-panel]');
    const activate = (slug) => {
      tabs.forEach((t) => {
        const on = t.getAttribute('data-loy-tier-tab') === slug;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach((p) => {
        p.classList.toggle('is-active', p.getAttribute('data-loy-tier-panel') === slug);
      });
    };
    tabs.forEach((t) => t.addEventListener('click', () => activate(t.getAttribute('data-loy-tier-tab'))));
    // Keyboard nav (arrow left/right między tabami)
    tiersRoot.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      const focused = document.activeElement;
      if (!focused || !focused.matches('[data-loy-tier-tab]')) return;
      const arr = Array.from(tabs);
      const idx = arr.indexOf(focused);
      if (idx < 0) return;
      e.preventDefault();
      const next = e.key === 'ArrowRight' ? (idx + 1) % arr.length : (idx - 1 + arr.length) % arr.length;
      arr[next].focus();
      activate(arr[next].getAttribute('data-loy-tier-tab'));
    });
  }

  // 4) Sticky mini CTA — pokazuje po hero, chowa gdy widoczny final CTA.
  const stickyCTA = document.querySelector('[data-loy-sticky-cta]');
  const hero = root.querySelector('[data-loy-hero]');
  const finalCTA = root.querySelector('[data-loy-final-cta]');

  if (stickyCTA && hero && 'IntersectionObserver' in window) {
    let heroVisible = true;
    let finalVisible = false;
    const update = () => {
      const show = !heroVisible && !finalVisible;
      stickyCTA.classList.toggle('is-shown', show);
    };
    const heroIO = new IntersectionObserver((entries) => {
      heroVisible = entries[0].isIntersecting;
      update();
    }, { threshold: 0.1 });
    heroIO.observe(hero);

    if (finalCTA) {
      const finalIO = new IntersectionObserver((entries) => {
        finalVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.1 });
      finalIO.observe(finalCTA);
    }
  }
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initLoyaltyMotion();
  else document.addEventListener('DOMContentLoaded', initLoyaltyMotion);
}

export {};
